<template>
  <div>
    <SnackBar />
    <router-view></router-view>
  </div>
</template>
<script>
//import colors from 'vuetify/lib/util/colors'
import SnackBar from "@/components/Widgets/SnackBar.vue";
export default {
  components: {
    SnackBar
  },
  beforeCreate() {
    //this.$vuetify.theme.themes.light.primary = colors.lightGreen
    // Check for cookies allowed
    try {
      localStorage.setItem(
        "TAjYWQB2yedPHE0PGQ7UVHPgTJmcgo5h",
        "TAjYWQB2yedPHE0PGQ7UVHPgTJmcgo5h"
      );
      localStorage.removeItem("TAjYWQB2yedPHE0PGQ7UVHPgTJmcgo5h");
    } catch (err) {
      console.log(err);
      this.$router.replace({ path: "/no-cookies" });
    }
  }
};
</script>
<style>
body .theme--light.v-application {
  background: rgb(242, 242, 242) none repeat scroll 0% 0%;
  color: rgba(0, 0, 0, 0.87);
}
</style>
